/**
 * search-quotes.js
 * Jay's Toys & Games — dynamic search placeholder quotes.
 * Random per page load; slow-cycles with a subtle fade. Never animates while the
 * user is typing in the drawer. Plain script (no custom element) — soft-refresh safe.
 */

const QUOTES = [
  "One Search to rule them all…",
  "Use the Search, Luke.",
  "The cake is a lie… but the Search is real.",
  "I am the one who searches.",
  "It's dangerous to go alone. Search this.",
  "There is no spoon. But the figure is here.",
  "Do a barrel search.",
  "Stay a while and search.",
  "I have been, and always shall be, hunting.",
  "Winter is coming. Pre-orders aren't.",
  "The Search must flow.",
  "Ph'nglui mglw'nafh — or just search.",
  "Gotta catch 'em all. Might as well search.",
  "This is the way… to checkout.",
  "I've seen things you wouldn't believe. Search them anyway.",
  "Why do we search? So we can buy.",
  "With great search comes great responsibility.",
  "I am Groot. Search Groot.",
  "We do not say 'Add to Cart.' We say 'It is known.'",
  "Leeeeeroy Jen… just search first.",
  "You either die a completionist or live long enough to see yourself search.",
  "Hello there. Search something.",
  "Strong enough to search alone. Smart enough not to.",
  "E.T. search home.",
  "Believe it. Search it.",
  "I'll be back. You search.",
  "Did I do that? (Search before it sells out.)",
  "It's super effective.",
  "Just a flesh wound. The inventory is fine.",
  "Resistance is futile. The checkout button is right there.",
];

const CYCLE_INTERVAL_MS = 45000; // ambient, not intrusive
const FADE_DURATION_MS = 200;

function pickRandom(current) {
  if (QUOTES.length <= 1) return QUOTES[0];
  let next;
  do {
    next = QUOTES[Math.floor(Math.random() * QUOTES.length)];
  } while (next === current);
  return next;
}

function applyQuote(el, text) {
  if (el.tagName === 'INPUT') {
    el.placeholder = text;
  } else {
    el.textContent = text;
  }
}

function setQuote(el, text) {
  // Never disturb the placeholder while the user is typing in that field.
  if (el.tagName === 'INPUT' && document.activeElement === el) return;
  el.classList.add('quotes-transitioning');
  setTimeout(() => {
    applyQuote(el, text);
    el.classList.remove('quotes-transitioning');
  }, FADE_DURATION_MS);
}

function initSearchQuotes() {
  const targets = document.querySelectorAll('[data-search-quotes]');
  if (!targets.length) return;

  let currentQuote = pickRandom(null);
  targets.forEach((el) => applyQuote(el, currentQuote));

  setInterval(() => {
    const next = pickRandom(currentQuote);
    targets.forEach((el) => setQuote(el, next));
    currentQuote = next;
  }, CYCLE_INTERVAL_MS);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSearchQuotes);
} else {
  initSearchQuotes();
}
